export default "__VITE_ASSET__BvUPnrV8__"